import React, {useContext, useEffect, useState} from 'react';
import { auth } from '../../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

const AuthContext = React.createContext();

export function useAuth(){
    return useContext(AuthContext);
}

export function AuthProvider({children})
{
    const [currentUser, setCurrentUser] = useState(null);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState(null);

    useEffect(()=>{
        const unsubscribe = onAuthStateChanged(auth, initializeUser);
        return unsubscribe;
    },[])

    async function initializeUser(user){
        if(user){
            setCurrentUser({...user});
            setUserLoggedIn(true);

            // const storedRole = sessionStorage.getItem("userRole");
            // if (storedRole)
            // {
            //     setRole(storedRole);
            //     console.log(storedRole);
            // }
            // else{
                await user.getIdToken(true);
                const idTokenResult = await user.getIdTokenResult();
                
            if (!idTokenResult.claims.role) {
                // If role isn't found, retry after a delay
                setTimeout(async () => {
                    const updatedIdTokenResult = await user.getIdTokenResult();
                    console.log("Updated Role:", updatedIdTokenResult.claims.role);
                }, 1000); // Adjust delay as needed

            } else {
                sessionStorage.setItem("userRole", idTokenResult.claims.role);
                console.log(idTokenResult.claims.role);
                console.log(user);
                setRole(idTokenResult.claims.role || null);
            }
        }
        else{
            setCurrentUser(null);
            setUserLoggedIn(false);
            setRole(null);
            sessionStorage.removeItem("userRole");
            console.log("clear all");
        }
        setLoading(false);
    }

    
    const value ={
        currentUser,
        userLoggedIn,
        loading,
        role,
        initializeUser
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}